import {
    accompanyAddInit,
    accompanyAddRecord,
    getAccoVisitList
  } from '@/api'
export default {
  async getAccompanyAddInit ({ commit, state }, params = {}) {
    const res = await accompanyAddInit(params)
    const initIndicatorList = res.indicatorList
    const visitedBdList = res.visitedBdList

    commit('updateIndicatorList', initIndicatorList)
    commit('updatedBdList', visitedBdList)
  },
  async accompanyAddRecord ({commit, state}, params = {}) {
    const recordId = await accompanyAddRecord(params)
    return recordId
  },
  async getVisitList ({commit, state}, params = {}) {
    const {reset, ...LParams} = params

    const visitedListData = await getAccoVisitList(LParams)
    commit('upDateVisitData', { visitedListData, reset })
  }

}
